import { faHexagon } from "@fortawesome/pro-regular-svg-icons";

import { ItemIcon } from "src/omnibox/ItemIcon";

export const buildVariableItem = (
  label: string,
  onSelect: (searchTerm: string) => void,
) => {
  return {
    label: label,
    icon: (
      <ItemIcon bgColor="bg-gray-100" color="text-gray-500" icon={faHexagon} />
    ),
    type: "Variable",
    details: "",
    value: label,
    onSelect: () => onSelect(label),
    dataLoc: `omnibox-variable-search-${label}`,
  };
};
